import aspectRatio from '@tailwindcss/aspect-ratio';

/** @type {import('tailwindcss').Config} */
export default {
    content: [
        './storage/framework/views/*.php',
        './resources/**/*.blade.php',
        './resources/**/*.js',
        './resources/**/*.vue'
    ],
    safelist: [
        {
            pattern: /^(text|border)-course-/,
        }, {
            pattern: /^(text|bg-)-grade-league-/,
        }, {
            pattern: /^(text|bg-)-league-/,
        }, {
            pattern: /^shadow-award-/,
        },
    ],
    important: true,
    theme: {
        fontFamily: {
            'sans': ['Nunito', 'sans-serif'],
        },
        extend: {
            colors: {
                'primary': {
                    'darkest': '#0093B3',
                    'default': '#0AB1B9',
                    '900': '#065F64',
                    '700': '#055458',
                    '600': '#078389',
                    '550': '#027d82',
                    '500': '#03B0B9',
                    '400': '#15B4BC',
                    '300': '#22B9C0',
                    'light': '#43C2CC',
                    'lightest': '#3BC1C7',
                    '50': '#09B9C11A',
                },
                'secondary': '#E50069',
                'secondary-50': 'rgba(229,0,105,0.24)',
                'gray': {
                    '990': '#231F20',
                    '980': '#3c3828',
                    '960': '#434343',
                    '955': '#4D6077',
                    '950': '#616161',
                    '900': '#606060',
                    '850': '#7C7C7C',
                    '830': '#898989',
                    '800': '#8F8F8F',
                    '700': '#A6A8A9',
                    '600': '#B0B0B0',
                    '500': '#DEDEDF',
                    '450': '#D6DFE3',
                    '400': '#EDF1F3',
                    '300': '#E6E8EB',
                    '250': '#E0E4E6',
                    '200': '#F1F4F5',
                    '100': '#F7FAFC',
                    '50': '#FDFEFE',
                },
                'yellow': {
                    'default': '#FCD638',
                },
                'lime': {
                    'default': '#9BBA63',
                },
                'contact': {
                    'whatsapp': '#25D366',
                },
                'footer': '#FBFCFC',
                'footer-top': '#7ABECC',
                'background': '#edf1f3',
                'course': {
                    1: '#cc2f3c',
                    2: '#fa861b',
                    3: '#f7be48',
                    4: '#43c2cc',
                    5: '#43c2cc',
                    6: '#1aa3d9',
                    8: '#4A69BD',
                    9: '#B8E994',
                    10: '#079992',
                    11: '#C44569',
                    12: '#F19066',
                    13: '#6C5CE7',
                    14: '#84817A',
                    15: '#40407A',
                    16: '#E84118',
                    17: '#0a466b',
                    18: '#F7B731',
                    19: '#fa861b',
                    20: '#0a466b',
                    21: '#cc2f3c',
                    22: '#4A69BD',
                    23: '#F19066',
                    24: '#6C5CE7',
                    25: '#f7be48',
                    26: '#84817A',
                    27: '#40407A',
                    28: '#E84118',
                    29: '#1aa3d9',
                    30: '#C44569',
                    31: '#B8E994',
                    32: '#fa861b',
                    33: '#079992',
                    34: '#43c2cc',
                    35: '#fa861b',
                    36: '#1aa3d9',
                    37: '#C44569',
                    38: '#B8E994',
                    39: '#1aa3d9',
                    40: '#652d91'
                },
                'panel-card': {
                    1: '#cc2f3c',
                    2: '#6C5CE7',
                    3: '#079992',
                    4: '#1aa3d9',
                    5: '#4A69BD',
                    6: '#fa861b',
                },
                'grade-league': {
                    1: '#f7be48',
                    2: '#cc2f3c',
                    3: '#fa861b',
                    4: '#1aa3d9',
                },
                'league': {
                    1: '#05C46B',
                    2: '#0FB9B1',
                    3: '#2D98DA',
                },
                'status': {
                    'success': '#47C28E',
                    'warning': '#E3B909',
                    'danger': '#EC6A5D'
                },
                'toast': {
                    'warning': '#FFD965'
                }
            },
            fontSize: {
                '4xs': '.3125rem',
                '3xs': '.468rem',
                '2xs': '.625rem',
                'none': '0rem',
                '8xl': '6rem',
            },
            maxWidth: {
                '8xs': '4rem',
                '4xs': '8rem',
                '3xs': '12rem',
                '2xs': '16rem',
                'sm': '24rem',
                '2xl': '74rem',
                '3xl': '88rem',
                '1/4': '25%',
                '1/2': '50%',
                '3/5': '60%',
                '3/4': '75%',
                '4/5': '80%',
                '19/20': '95%'
            },
            maxHeight: {
                '9/10': '90%',
                '19/20': '95%'
            },
            borderRadius: {
                '4xl': '2rem',
                '6xl': '3rem'
            },
            boxShadow: {
                'award-1': '9px 0 0px -5px #05C46B',
                'award-2': '9px 0 0px -5px #0FB9B1',
                'award-3': '9px 0 0px -5px #2D98DA',
                'flat': '0 0 9px 4px rgba(0, 0, 0, 0.1)'
            },
            'spacing': {
                '4.5': '1.125rem',
                '18': '4.5rem',
                '26': '6.5rem',
                '76': '18rem',
                '78': '19rem',
                '88': '22rem',
                '104': '26rem',
                '120': '30rem',
                '128': '32rem'
            },
            'opacity': {
                '15': '.15'
            },
            backgroundImage: theme => ({
                'grounded': "url('/img/landing/ground.png')",
                'gradient-conic': 'conic-gradient(var(--tw-gradient-stops))'
            }),
            cursor: {
                'zoom-in': 'zoom-in'
            },
            aspectRatio: {
                17: '17'
            },
            translate: {
                'neg-1/2': '-50%',
            },
            strokeWidth: {
                '3': '3px'
            },
            keyframes: {
                wiggle: {
                    '0%': {transform: 'rotate(-10deg) scale(0.5)'},
                    '100%': {transform: 'rotate(0deg) scale(1)'},
                },
                disco: {
                    '0%': { transform: 'translateY(-50%) rotate(0deg)' },
                    '100%': { transform: 'translateY(-50%) rotate(360deg)' },
                }
            },
            animation: {
                disco: 'disco 1.5s linear infinite',
            }
        },
        screens: {
            '3xs': '320px',
            '2xs': '360px',
            'xs': '475px',
            'sm': '640px',
            'md': '768px',
            'lg': '992px',
            'xl': '1200px',
            '2xl': '1536px',
            '3xl': '1600px',
        },
        container: {
            center: true,
            padding: {
                DEFAULT: '1rem',
                '2xl': '6rem',
            },
        }
    },
    plugins: [
        aspectRatio,
    ],
}
